import * as React from "react";
import { NavLink, useLocation } from "react-router-dom";
import homeIcon from "../../../lease_management/assets/img/home_icon.svg";
import dashboardIcon from "../../../lease_management/assets/img/dashboard_icon.svg";
import assetIcon from "../../../lease_management/assets/img/asset_icon.svg";
import leasesIcon from "../../../lease_management/assets/img/leases_icon.svg";
import utilizationIcon from "../../../lease_management/assets/img/util_icon.svg";
import innvoicesIcon from "../../../lease_management/assets/img/invoices_icon.svg";
import cashflowsIcon from "../../../lease_management/assets/img/cashflows_icon.svg";
import ClaimsIcon from "../../../lease_management/assets/img/claim_icon.svg";
import reportsIcon from "../../../lease_management/assets/img/reports_icon.svg";
import settingIcon from "../../../lease_management/assets/img/setting_icon.svg";
import analyticsIcon from "../../../lease_management/assets/img/analytics_icon.svg";

import homeIconWhite from "../../../lease_management/assets/img/white-icons/home-white.svg";
import leasesIconWhite from "../../../lease_management/assets/img/white-icons/lease-white.svg";
import dashboardIconWhite from "../../../lease_management/assets/img/white-icons/dashboard-white.svg";
import assetIconWhite from "../../../lease_management/assets/img/white-icons/asset-white.svg";
import utilizationIconWhite from "../../../lease_management/assets/img/white-icons/utilisation-white.svg";
import innvoicesIconWhite from "../../../lease_management/assets/img/white-icons/invoice-white.svg";
import cashflowsIconWhite from "../../../lease_management/assets/img/white-icons/cashflow-white.svg";
import reportsIconWhite from "../../../lease_management/assets/img/white-icons/report-white.svg";
import settingIconWhite from "../../../lease_management/assets/img/white-icons/setting-white.svg";
import analyticsIconWhite from "../../../lease_management/assets/img/white-icons/analytics_white.svg";
import appConfig from "../../../config";
import { imgStoragePath } from "../../../constants";
// import AIAssistantPopup from "./AIAssistantPopup";
import { getGlobalCookie } from "../../../utils";
const PryNavLink = () => {
  const location=useLocation();
  const domain = appConfig.domain.subDomian;
  const { id: lessorId = "" } = JSON.parse(getGlobalCookie("lessorAccess") || "{}");
    
  const sidebarNavLinks = [
    // {
    //   path:`${domain}`,
    //   label: "Home",
    //   icon: homeIcon,
    //   activeIcon: homeIconWhite,
    // },
    {
      path: "/dashboard",
      label: "Home",
      icon: homeIcon,
      activeIcon: homeIconWhite,
    },
    {
      path: "/assets",
      label: "Assets",
      icon: assetIcon,
      activeIcon: assetIconWhite,
    },
    {
      path: "/leases",
      label: "Leases",
      icon: leasesIconWhite,
      activeIcon: leasesIcon,
    },
    {
      path: "/utilization",
      label: "Utilization",
      icon: utilizationIcon,
      activeIcon: utilizationIconWhite,
    },
    {
      path: "/invoices",
      label: "Invoices",
      icon: innvoicesIcon,
      activeIcon: innvoicesIconWhite,
    },
    {
      path: "/cashflow",
      label: "Cashflow",
      icon: cashflowsIcon,
      activeIcon: cashflowsIconWhite,
    },
    {
      path: "/claims",
      label: "Claims",
      icon: ClaimsIcon,
      activeIcon: ClaimsIcon,
    },
    {
      path: "/reports",
      label: "Reports",
      icon: reportsIcon,
      activeIcon: reportsIconWhite,
    },
    {
      path: "/analytics",
      label: "Analytics",
      icon: analyticsIcon,
      activeIcon: analyticsIconWhite,
    },
    {
      path: "/activities",
      label: "Activities",
      icon: `${imgStoragePath}report_icon.png`,
      activeIcon:`${imgStoragePath}report_icon.png`,
    },
    {
      path: "/settings/party-role",
      label: "Settings",
      icon: settingIcon,
      activeIcon: settingIconWhite,
    },
  ];

  const isPathActive = (path) => {
    if (path === '/leases') {
      return location.pathname === '/leases' || location.pathname.startsWith("/lease/")
    }
    if (path === '/settings/party-role') {
      return location.pathname === '/settings/party-role' || location.pathname.startsWith('/settings')
    }
    if (location.pathname === path) return true;

    return false;
  }

  return (
    <div className="primary-side-nav" style={{overflow: 'auto'}}>
      {sidebarNavLinks.map(({ label, path, icon, activeIcon }) => {
        const isActive = isPathActive(path)
        return (
        <div className="menu-link" key={path}>
          <NavLink
            to={path}
            className={isActive ? "active" : ""}
            target="_self"
          >
            {({ isActive }) => (
              <>
                <img src={isActive ? activeIcon : icon} alt={label} />
                <p>{label}</p>
              </>
            )}
          </NavLink>
        </div>
        );
     })}
      {/* {<AIAssistantPopup />} */}
    </div>
  );
};
export default PryNavLink;
